export default __webpack_public_path__ + "static/media/tela_backupbasic.0c07041b.png";